import FlexPane from './_flex-pane.js'
import SelectableButtonGroup from './_selectable-button-group.js'
import SwitchPane from './_switch-pane.js'

export default {
  name: 'TabbedPane',
  values: {
    container: {
      configSet: FlexPane,
      configValues: {
        style: {
          flexDirection: 'column',
          width: '100%',
        },
      },
    },
    tabButtons: {
      configSet: SelectableButtonGroup,
      configValues: {
        selectableButton: {
          unselected: {
            style: {
              base: {
                flexBasis: '0px',
              },
            },
          },
          selected: {
            style: {
              base: {
                flexBasis: '0px',
              },
            },
          },
        },
      },
    },
    contentContainer: {
      configSet: SwitchPane,
      configValues: {},
    },
  },
  meta: {
    extendable: false,
  },
}
